import { createSlice } from '@reduxjs/toolkit';
import { resetApplication } from '../application/slice';
import locationState from './state';
export const locationSlice = createSlice({
    extraReducers: builder => {
        builder.addCase(resetApplication, () => locationState);
    },
    initialState: locationState,
    name: 'location',
    reducers: {
        errorReceiveLocation: state => {
            state.location = undefined;
            state.requestingLocation = false;
        },
        failedReceiveLocation: state => {
            state.location = undefined;
            state.requestingLocation = false;
        },
        receiveLocation: {
            prepare: location => {
                return {
                    payload: {
                        location
                    }
                };
            },
            reducer: (state, action) => {
                const { location } = action.payload;
                state.location = location;
                state.requestingLocation = false;
            }
        },
        requestLocation: {
            prepare: (slug, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        slug
                    }
                };
            },
            reducer: state => {
                state.requestingLocation = true;
            }
        },
        resetLocation: () => locationState
    }
});
export const { errorReceiveLocation, failedReceiveLocation, receiveLocation, requestLocation, resetLocation } = locationSlice.actions;
export default locationSlice.reducer;
